import { DialogActions, Button } from "@mui/material";
import React from "react";
import GlobalButton from "../CustomButton";
import { useTranslation } from "react-i18next";

const DialogActionButtons = ({
    onConfirm,
    onCancel,
    confirmText = "confirm",
    cancelText = "cancel",
    isConfirmBtnDisable = false,
    showCancelButton = true,
    showConfirmButton = true,
}) => {
    const { t } = useTranslation(["common"]);
    return (
        <DialogActions
            sx={{
                padding: "12px",
            }}
        >
            {showCancelButton && (
                <GlobalButton
                    variant={"outlined"}
                    handleClickBtn={onCancel}
                    btnText={t(cancelText)}
                />
            )}
            {showConfirmButton && (
                <GlobalButton
                    variant={"contained"}
                    handleClickBtn={onConfirm}
                    btnText={t(confirmText)}
                    disabled={isConfirmBtnDisable}
                />
            )}
        </DialogActions>
    );
};

export default DialogActionButtons;
